import React from 'react';
import { useSelector } from 'react-redux';

import { loadingOpenSelector } from '@store/loading/selectors';
import LoadingFull from '@components/LoadingFull';

const LoadingHooked: React.FC = () => {
  const open = useSelector(loadingOpenSelector);
  return <LoadingFull open={open} />;
};

export default LoadingHooked;
